import React, { useCallback, useState } from "react";
import ConfirmModal from "../components/ConfirmModal";

type ConfirmOptions = {
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    tone?: "danger" | "primary";
};

export const useConfirm = () => {
    const [open, setOpen] = useState(false);
    const [opts, setOpts] = useState<ConfirmOptions>({ message: "" });
    const [resolver, setResolver] = useState<((v: boolean) => void) | null>(null);

    const confirm = useCallback((options: ConfirmOptions) => {
        setOpts(options);
        setOpen(true);
        return new Promise<boolean>((resolve) => {
            setResolver(() => resolve);
        });
    }, []);

    const onConfirm = () => {
        setOpen(false);
        resolver?.(true);
        setResolver(null);
    };

    const onCancel = () => {
        setOpen(false);
        resolver?.(false);
        setResolver(null);
    };

    const ConfirmUI = (
        <ConfirmModal
            open={open}
            title={opts.title}
            message={opts.message}
            confirmText={opts.confirmText}
            cancelText={opts.cancelText}
            tone={opts.tone}
            onConfirm={onConfirm}
            onCancel={onCancel}
        />
    );

    return { confirm, ConfirmUI };
};